import * as Yup from 'yup';

export default Yup.object().shape({
  attachments: Yup.object().shape({
    valuation: Yup.object()
      .shape({
        lastModified: Yup.number(),
        lastModifiedDate: Yup.date(),
        name: Yup.string(),
        size: Yup.number(),
        type: Yup.string(),
        webkitRelativePath: Yup.string(),
      })
      .nullable(),
    personal: Yup.object()
      .shape({
        lastModified: Yup.number(),
        lastModifiedDate: Yup.date(),
        name: Yup.string(),
        size: Yup.number(),
        type: Yup.string(),
        webkitRelativePath: Yup.string(),
      })
      .nullable(),
    other: Yup.object()
      .shape({
        lastModified: Yup.number(),
        lastModifiedDate: Yup.date(),
        name: Yup.string(),
        size: Yup.number(),
        type: Yup.string(),
        webkitRelativePath: Yup.string(),
      })
      .nullable(),
  }),
});
